import BaseEntity from './BaseEntity';
import SimplePullRequestMetric from './SimplePullRequestMetric';
export default class PullRequestsMetric extends BaseEntity {
    constructor(sprint, daily) {
        super();
        this.daily = [];
        this.sprint = new SimplePullRequestMetric(sprint);
        if (daily.length) {
            this.daily = daily.map((day) => new SimplePullRequestMetric(day));
        }
    }
}
